module.exports = __webpack_public_path__ + "img/benefit-2-alt.0763afba.png";